import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Layout, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { reportingOp } from 'store/ducks/Reporting';
import { RootState } from 'store/configureStore';
import {
  TitleListEN,
  TitleListDE,
  TitleListES,
  TitleListFR,
  TitleListIT,
  TitleListPT
} from 'store/ducks/globalTypes';
import { IReportingLayoutProps } from 'store/ducks/Reporting/types';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import * as Styled from 'components/Layouts/Layout.styled';

const { Sider } = Layout;
const { useToken } = theme;
const { Content } = Layout;

const ReportingLayout: React.FC<IReportingLayoutProps> = ({
  activeTab,
  activeKey,
  children
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token } = useToken();
  const { t } = useTranslation();

  const { lang, scheme } = useSelector((state: RootState) => ({
    lang: state.global.lang,
    scheme: state.global.scheme
  }));

  useEffect(() => {
    dispatch(reportingOp.setDrawTable(false));
  }, [activeTab, activeKey]);

  const getTitle = () => {
    switch (lang) {
      case 'de':
        return TitleListDE.REPORTING;
      case 'es':
        return TitleListES.REPORTING;
      case 'fr':
        return TitleListFR.REPORTING;
      case 'it':
        return TitleListIT.REPORTING;
      case 'pt':
        return TitleListPT.REPORTING;
      default:
        return TitleListEN.REPORTING;
    }
  };

  const getBackButtons = () => {
    const isBusinessProcessReporting =
      location.pathname.includes('reporting_risk_controls') ||
      location.pathname.includes('/risk-controls/reportings');

    if (isBusinessProcessReporting) {
      return (
        <>
          <GoBackButton to='/internal_controls' text={t('GO_BACK')} />
          <GoBackButton to='/working_area' text={t('GO_TO_WORKING_AREAS')} />
        </>
      );
    }

    return (
      <>
        <GoBackButton
          to='/workingAreaDetails/rules-to-evidence'
          text={t('GO_TO_COMPLIANCE_HUB')}
        />
        <GoBackButton to='/working_area' text={t('GO_TO_WORKING_AREAS')} />
      </>
    );
  };

  return (
    <>
      <Styled.GlobalThemeStyles scheme={scheme} />
      <Styled.StyledLayout token={token} scheme={scheme}>
        <TitleBar title={getTitle()} goBackButtons={getBackButtons()} />
        <Styled.StyledLayout token={token} scheme={scheme}>
          <Layout>
            <Content>{children}</Content>
          </Layout>
          <Sider />
        </Styled.StyledLayout>
      </Styled.StyledLayout>
    </>
  );
};

export default ReportingLayout;
